/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React, { useState } from 'react';
import envConfig from '../config/envConfig';
import GaneshaLogo from './GaneshaLogo';
import { useTheme } from '../theme/ThemeContext';
import Button from './Button';
import '../styles/Header.css';
import { useNavigate } from 'react-router-dom';
import { retrieve } from '../utils/storageHelper';

function Header() {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const [user, setUser] = React.useState(null);

    React.useEffect(() => {
        const userData = retrieve('userData');
        if (userData) {
            setUser(userData);
        }
    }, []);

    const handleSignInClick = () => {
        navigate('/sign-in');
    };

    const handleSignUpClick = () => {
        navigate('/sign-up')
    }

    return (
        <nav
            className="navbar navbar-expand-lg navbar-light py-2"
            style={{
                background: 'white',
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
            }}
        >
            <div className="container-fluid">
                <a
                    className="navbar-brand d-flex align-items-center gap-2"
                    href="/"
                    style={{
                        color: theme.primary,
                        fontWeight: 700,
                        fontSize: '1.45rem',
                        textTransform: 'capitalize',
                        letterSpacing: '0.3px'
                    }}
                >
                    <GaneshaLogo height={36} width={36} color={theme.primary} />
                    <span className="ms-2">{envConfig.appName}</span>
                </a>
                {/* Hamburger for mobile */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#headerNav"
                    aria-controls="headerNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    style={{ border: `2px solid ${theme.primary}` }}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse flex-grow-0" id="headerNav">
                    <ul className="navbar-nav ms-auto">
                        {user ? (
                            <li className="nav-item">
                                <Button mode="primary" className="w-lg-auto" onClick={() => navigate('/dashboard')}>
                                    Dashboard <i className="bi bi-arrow-right ms-2"></i>
                                </Button>
                            </li>
                        ) : (
                            <>
                                <li className="nav-item mb-2 mb-lg-0">
                                    <Button mode="primary" className="me-lg-2 w-lg-auto" onClick={handleSignInClick}>
                                        Sign In
                                    </Button>
                                </li>
                                <li className="nav-item">
                                    <Button mode="bordered" className="w-lg-auto" onClick={handleSignUpClick}>
                                        Sign Up
                                    </Button>
                                </li>
                            </>
                        )}
                    </ul>
                </div>

            </div>
        </nav>
    );
}

export default Header;
